import React from "react";
import { LegalPage } from "./legal/LegalPage";

export const AccountCancellation = () => (
  <LegalPage namespace="legalAccountCancellation" />
);
